export default __webpack_public_path__ + "static/media/fixedprice.e195f891.png";